/**
 * Locations API — Supabase PostgREST.
 */

import supabase from "../config/supabase";

const locationsApi = {
  async list(params = {}) {
    let query = supabase.from("locations").select("*").order("name", { ascending: true });
    if (params.state) query = query.eq("state", params.state);
    const { data, error } = await query;
    if (error) return { success: false, error: error.message };
    return { success: true, data: data || [] };
  },
};

export default locationsApi;
